import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./lib/auth";
import Layout from "./components/Layout";
import { RequireAuth } from "./components/common";
import Home from "./pages/Home";
import About, { CmsPage } from "./pages/About";
import Membership from "./pages/Membership";
import Library, { LibraryItem } from "./pages/Library";
import Events, { EventDetail } from "./pages/Events";
import News, { NewsPost, Contact, DemoAccess } from "./pages/News";
import { Login, Register, VerifyEmail, ForgotPassword, ResetPassword } from "./pages/AuthPages";
import Checkout from "./pages/Checkout";
import Dashboard from "./pages/Dashboard";
import Directory, { MemberProfile } from "./pages/Directory";
import Circles, { CircleDetail, Thread } from "./pages/Circles";
import AdminLayout from "./admin/AdminLayout";
import { AdminOverview, AdminMembers } from "./admin/AdminMembers";
import AdminContent from "./admin/AdminContent";
import AdminHealth from "./admin/AdminHealth";
import { AdminApprovals, AdminRegistrations, AdminForum, AdminContacts, AdminOutbox, AdminMatches, AdminExports, AdminAudit, AdminSettings } from "./admin/AdminMisc";
import ChatWidget from "./components/ChatWidget";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

const NotFound = () => <div className="kh-container py-24"><h1 className="text-5xl">Page not found</h1><p className="mt-3">That page has been fired a little too hot. <a href="/" className="underline decoration-ochre">Return home</a>.</p></div>;
const Auth = ({ children }) => <RequireAuth>{children}</RequireAuth>;

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollTop />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/p/:slug" element={<CmsPage />} />
            <Route path="/membership" element={<Membership />} />
            <Route path="/library" element={<Library />} />
            <Route path="/library/:slug" element={<LibraryItem />} />
            <Route path="/events" element={<Events />} />
            <Route path="/events/:slug" element={<EventDetail />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/:slug" element={<NewsPost />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/demo-access" element={<DemoAccess />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/directory" element={<Directory />} />
            <Route path="/directory/:id" element={<MemberProfile />} />
            <Route path="/circles" element={<Circles />} />
            <Route path="/circles/:slug" element={<Auth><CircleDetail /></Auth>} />
            <Route path="/threads/:id" element={<Auth><Thread /></Auth>} />
            <Route path="/checkout" element={<Auth><Checkout /></Auth>} />
            <Route path="/dashboard" element={<Auth><Dashboard /></Auth>} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/admin" element={<RequireAuth admin><AdminLayout /><ChatWidget /></RequireAuth>}>
            <Route index element={<AdminOverview />} />
            <Route path="members" element={<AdminMembers />} />
            <Route path="content" element={<AdminContent />} />
            <Route path="approvals" element={<AdminApprovals />} />
            <Route path="registrations" element={<AdminRegistrations />} />
            <Route path="forum" element={<AdminForum />} />
            <Route path="contacts" element={<AdminContacts />} />
            <Route path="outbox" element={<AdminOutbox />} />
            <Route path="matches" element={<AdminMatches />} />
            <Route path="health" element={<AdminHealth />} />
            <Route path="exports" element={<AdminExports />} />
            <Route path="audit" element={<AdminAudit />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
